module.exports = __webpack_public_path__ + "img/55.3c9a6cb4.jpg";